import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../shared/services/login.service';


@Injectable({
  providedIn: 'root'
})
export class UserAuthenticatedGuard {
  private readonly login = inject(LoginService);
  private readonly router = inject(Router);


  public canActivate(): boolean {
    if (this.login.user) {
      return true;
    } else {
      this.login.logout();
      this.router.navigate(['/login']);
      return false;
    }
  }

}
